import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { TabsProps, TabsState, Tabs, Tab } from '../Tabs';
import NewVendorProfilesTab from './NewVendorProfilesTab';
import QCEWTab from "./QCEWTab"
import { loadNewVendorReportTab1, loadNewVendorSharedReport, sliderChange} from '../../../actions/VendorReportActions';
import { UserVendorReportState, VendorReportAction } from '../../../interface/VendorReportInterface';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../reducers/Index';
import NewVendorSunburst from './NewVendorSunburst';
import ViewReportModal from '../ViewReportModal';
import MethodologyTab from './MethodologyTab';
import { isAgg } from '../../Common/Helpers';

// track user visit
import { withUserActionTracker } from '../../../sharedUtilities/UserActionTracker';

class NewVendorReportTabPanel extends React.Component<VendorReportAction & UserVendorReportState & RouteComponentProps<{}>, TabsState> {
    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {
            this.props.loadNewVendorSharedReport(this.props.match.params["link_id"],
                this.props.match.params["p1"],
                this.props.match.params["p2"]);
        }
        else {
            this.props.loadNewVendorReportTab1(this.props.UserState.report_display_id, this.props.UserState.report_census_vintage, this.props.UserState.report_vintage_vendor);
        }
    }

    render() {
        const sharedLinkPageOnLoad = this.props.match.params !== undefined && this.props.match.params["link_id"] !== undefined && this.props.match.params["p1"] !== undefined && this.props.match.params["p2"] !== undefined;
        const agg = isAgg(this.props.UserState.report_display_id)
        if (this.props.UserState.report_display_id == 999788)
            return (
                <div style={{marginTop:"40px"}}>
                    {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Vendor"} /> : null}
                    {this.props.VendorReportState.HomeState && this.props.VendorReportState.TrendsPar
                        && this.props.VendorReportState.SunburstBVDData_Updated
                        && this.props.VendorReportState.SunburstBVDData != null && this.props.VendorReportState.SunburstBVDData.length > 0
                        && this.props.VendorReportState.SunburstBulletPoint != null && this.props.VendorReportState.VendorReport_Tab4 != null ?
                        <NewVendorSunburst
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState.HomeState}
                            industryCount={this.props.VendorReportState.SunburstBVDData ? this.props.VendorReportState.SunburstBVDData.length : 0}
                            type="BVD"
                            decoratedData={this.props.VendorReportState.SunburstBVDData_Updated}
                            SunburstBVDData={this.props.VendorReportState.SunburstBVDData}
                            SunburstBulletPoint={this.props.VendorReportState.SunburstBulletPoint}
                            BVDYearRange={this.props.VendorReportState.TrendsPar}
                            VendorReport_Tab4={this.props.VendorReportState.VendorReport_Tab4}
                            VendorReport={this.props.VendorReportState}
                            ReportsConf={this.props.VendorReportState.ReportsConf}
                            agg={agg}
                        /> : <div>Loading...</div>
                    }
                </div>
        )
        else
        return (
            <div>
                {sharedLinkPageOnLoad && (!this.props.match.params["ne"]) ? <ViewReportModal filetype={"Vendor"} /> : null}
                <Tabs tabIndex={1}>
                    <Tab iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab1'}
                        tabName="Vendor Profile"
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        shouldShow={this.props.VendorReportState.VendorReport_Tab1}
                        tabIndex={0}
                        arialabel="Opening vendor profile tab"
                   >
                        <NewVendorProfilesTab
                            sliderChange={this.props.sliderChange}
                            selected_year={this.props.VendorReportState.selected_year}
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState.HomeState}
                            VendorProfile={this.props.VendorReportState.VendorProfile}
                            SpendingTotalByFips={this.props.SpendingReportState.SpendingTotalByFips}
                            TrendsPar={this.props.VendorReportState.TrendsPar}
                            VendorProfilesByYear={this.props.VendorReportState.VendorProfilesByYear}
                            BVDMatchRates={this.props.VendorReportState.BVDMatchRates}
                            VendorReport_Tab1={this.props.VendorReportState.VendorReport_Tab1}
                            ReportsConf={this.props.VendorReportState.ReportsConf}
                            agg={agg}
                        />
                    </Tab>
                    <Tab iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab4'}
                        tabName="Industry Revenue Analysis"
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        shouldShow={this.props.VendorReportState.SunburstBVDData != null && this.props.VendorReportState.SunburstBVDData.length > 0}
                        arialabel="Opening industry revenue analysis tab"
                    >
                        <NewVendorSunburst
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState.HomeState}
                            industryCount={this.props.VendorReportState.SunburstBVDData ? this.props.VendorReportState.SunburstBVDData.length : 0}
                            type="BVD"
                            decoratedData={this.props.VendorReportState.SunburstBVDData_Updated}
                            SunburstBVDData={this.props.VendorReportState.SunburstBVDData}
                            SunburstBulletPoint={this.props.VendorReportState.SunburstBulletPoint}
                            BVDYearRange={this.props.VendorReportState.TrendsPar}
                            VendorReport_Tab4={this.props.VendorReportState.VendorReport_Tab4}
                            VendorReport={this.props.VendorReportState}
                            ReportsConf={this.props.VendorReportState.ReportsConf}
                            agg={agg}
                        />
                    </Tab>
                    <Tab
                        iconClassName={'fa fa-headphones'}
                        linkClassName={'custom-link tab5'}
                        handleTabClickFromParent={this.props.handleTabClickFromParent}
                        tabName="Methodology"
                        arialabel="Opening methodology tab"
                    >
                        <MethodologyTab
                            display_id={this.props.UserState.report_display_id}
                            HomeState={this.props.VendorReportState.HomeState}
                            BVDMatchRates={this.props.VendorReportState.BVDMatchRates}
                            VendorReport_MatchRateTab={this.props.VendorReportState.VendorReport_MatchRateTab}
                            hasCensusData={this.props.VendorReportState.SunburstData && this.props.VendorReportState.SunburstData.length > 0}
                            agg={agg}
                            vendorRelease={this.props.VendorReportState.vendorRelease}
                        />
                    </Tab>
                </Tabs>
            </div>
        );
    }
}


const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    VendorReportState: state.vendorReportProperties,
    SpendingReportState: state.spendingReportProperties
});

const matchDispatchToProps = { loadNewVendorReportTab1, loadNewVendorSharedReport, sliderChange};

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(withUserActionTracker(NewVendorReportTabPanel, "Vendor Profile Report", "landing page"));
